import React from 'react';
import logo from "../../images/logo.png"
export default function Voice() {
    return (
      <section class="text-gray-600 body-font">
      <div class="container px-5 py-24 mx-auto">
      <h1 class="text-3xl font-bold title-font text-sky-600 mb-12 text-center">お客様の声</h1>
        <div class="flex flex-wrap -m-4">
          <div class="p-4 md:w-1/2 w-full">
            <div class="h-full bg-gray-100 p-8 rounded">
            <h1  class="block  mb-4 text-2xl font-medium title-font text-gray-900" >
                利用体験
              </h1>
              <p class="leading-relaxed mb-6">Synth chartreuse iPhone lomo cray raw denim brunch everyday carry neutra before they sold out fixie 90's microdosing. Tacos pinterest fanny pack venmo, post-ironic heirloom try-hard pabst authentic iceland.</p>
              <a class="inline-flex items-center">
                <img alt="testimonial" src="https://dummyimage.com/106x106" class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"/>
                <span class="flex-grow flex flex-col pl-4">
                  <span class="title-font font-medium text-gray-900">Holden Caulfield</span>
                  <span class="text-gray-500 text-sm">UI DEVELOPER</span>
                </span>
              </a>
            </div>
          </div>
          <div class="p-4 md:w-1/2 w-full">
            <div class="h-full bg-gray-100 p-8 rounded">
              <h1  class="block  mb-4 text-2xl font-medium title-font text-gray-900" >
                利用体験
              </h1>
              <p class="leading-relaxed mb-6">Synth chartreuse iPhone lomo cray raw denim brunch everyday carry neutra before they sold out fixie 90's microdosing. Tacos pinterest fanny pack venmo, post-ironic heirloom try-hard pabst authentic iceland.</p>
              <a class="inline-flex items-center">
                <img alt="testimonial" src="https://dummyimage.com/107x107" class="w-12 h-12 rounded-full flex-shrink-0 object-cover object-center"/>
                <span class="flex-grow flex flex-col pl-4">
                  <span class="title-font font-medium text-gray-900">Alper Kamu</span>
                  <span class="text-gray-500 text-sm">DESIGNER</span>
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
    )}

